<script setup lang="ts">
interface FairDialogHeaderProps {
  title?: string
}

withDefaults(defineProps<FairDialogHeaderProps>(), {
  title: 'Header',
})
</script>

<template>
  <header class="fair-dialog-header">
    <div
      v-if="$slots.start"
      class="fair-dialog-header__start"
    >
      <slot name="start" />
    </div>

    <h2 class="fair-dialog-header__title">
      <slot>
        {{ title }}
      </slot>
    </h2>

    <div
      v-if="$slots.end"
      class="fair-dialog-header__end"
    >
      <slot name="end" />
    </div>
  </header>
</template>
